
import HeaderForForm from '@/components/HeaderForForm';
import PowerOfAttorneyForm from '@/components/PowerOfAttorneyForm';
import { _prepareErrors } from '@/utils/_function.js';
import * as Api from '@/api';

export default {
  name: 'EditPowerOfAttorney',
  data() {
    return {
      formProcuratory: {},
      isDataSaving: false,
      isDisabled: false,
      isLoadData: false,
      defaultValueForm: {},
      currentProprietor: null
    };
  },
  components: {
    HeaderForForm,
    PowerOfAttorneyForm
  },
  created() {
    this.proxyId = this.$route.params.id;

    if (this.proxyId) {
      Api.getPowerOfAttorneyDetailData(this.proxyId)
        .then((response) => {
          this.proxyDetail = response.data.attributes;

          this.baseFile = this.proxyDetail.fileUrl;

          this.formProcuratory = {
            filerEmail: this.proxyDetail.filerEmail,
            endedAt: this.proxyDetail.endedAt,
            startedAt: this.proxyDetail.startedAt,
            file: this.proxyDetail.fileUrl,
            proprietorId: response.included[1].id
          };

          const list = [];
          list.push({
            id: this.proxyDetail.proprietorId.toString(),
            name: this.proxyDetail.proprietorName
          });
          this.currentProprietor = list;

          this.defaultValueForm = { ...this.formProcuratory };
          this.isLoadData = true;
        })
        .catch((error) => {
          this.$rollbar.warning(error);
        });
    } else {
      this.isLoadData = true;
    }
  },
  methods: {
    updatingData(value) {
      const { formProcuratory } = value;
      const data = {
        formProcuratory
      };

      this.isDataSaving = false;
      Object.assign(this.$data, data);
    },
    closeForm() {
      this.$router.push({ path: `/power-of-attorney` });
    },
    performFormAction() {
      this.isDataSaving = true;
    },
    savingData() {
      this.isDisabled = true;

      if (this.proxyId && this.formProcuratory.file === this.baseFile) {
        delete this.formProcuratory.file;
      }

      if (this.proxyId) {
        Api.editPowerOfAttorney(this.proxyId, this.formProcuratory)
          .then((response) => {
            if (response) {
              this.$toastr('success', this.$t('formProcuratory.successEditProcuratory'));
              this.$router.push({ path: `/power-of-attorney/${this.proxyId}` });
              this.isDisabled = false;
              this.$store.dispatch('getExpiringPowersOfAttorneyList');
            }
          })
          .catch((errors) => {
            if (errors) {
              _prepareErrors(errors).forEach((err) => {
                this.$toastr('error', err, 'Ошибка');
              });

              this.$rollbar.warning(errors);
              this.$toastr('error', this.$t('formProcuratory.errorEditProcuratory'), 'Ошибка');
            }
            this.isDisabled = false;
          });
      }
    }
  }
};
